export default "__VITE_ASSET__DCsIzyDd__"